import { useTranslation } from 'react-i18next';

import { StyledNewTag } from './styles';

export const NewTag = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <StyledNewTag className={className} data-automation="NewTag">
      {t('common.new')}
    </StyledNewTag>
  );
};
